import * as React from 'react';
import { fileAvatar } from 'utils/utils.files';

import styled from 'styled-components';
import { JRCFile } from './JRCFile';
import { JRCFileProps } from './types';

export const CSSFile = styled.div<{ size: number; backgroundColor: string }>`
    min-width: ${(props) => props.size}px;
    min-height: ${(props) => props.size}px;
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    border-radius: 8px;
    background-color: ${(props) => props.backgroundColor};
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        height: ${(props) => props.size / 1.6}px!important; // NEED THIS IMPORTANT TO BYPASS .content-html img
    }
`;

export const JRCFileAvatar = ({ uri, size, mimetype }: JRCFileProps) => {
    const file = fileAvatar(mimetype);
    return (
        <CSSFile size={size ?? 70} backgroundColor={file.colors.light}>
            <JRCFile uri={uri} mimetype={mimetype} display={'avatar'} />
        </CSSFile>
    );
};
